module.exports = __webpack_public_path__ + "media/images/training-5c079a42.png";